<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid">
      <v-tabs v-model="tab" grow>
        <v-tab>Dados da Escola</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- ABA 1: INFORMAÇÕES BÁSICAS -->
        <v-tab-item>
          <v-card class="mb-5">
            <v-card-title>Informações Gerais</v-card-title>
            <v-card-text>
              <v-row>
                <!-- Código INEP -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="formData.codigo"
                    label="Código INEP"
                    :rules="[codigoRule]"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Situação de Funcionamento -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="formData.situacao_funcionamento"
                    :items="['1 - Em Atividade', '2 - Paralisada', '3 - Extinta']"
                    label="Situação de Funcionamento"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Data de início e final do ano letivo -->
              <v-row v-if="formData.situacao_funcionamento === '1 - Em Atividade'">
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataInicioFormatada"
                        label="Data Início do Ano Letivo"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[requiredRule]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.data_inicio_ano_letivo"
                      no-title
                      @input="menuDataInicio = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuDataFinal"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFinalFormatada"
                        label="Data Final do Ano Letivo"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[requiredRule]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.data_final_ano_letivo"
                      no-title
                      @input="menuDataFinal = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <!-- Nome da escola -->
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.descricao"
                    label="Nome da Escola"
                    :rules="[requiredRule]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Zona -->
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="formData.zona"
                    :items="['1-Urbana', '2-Rural']"
                    label="Zona"
                    :rules="[zonaRule]"
                    required
                  ></v-select>
                </v-col>

                <!-- Localização Diferenciada -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="formData.localizacao_diferenciada"
                    :items="[
                      '1 – Comunidade quilombola',
                      '2 – Terra indígena',
                      '3 – Área de assentamento',
                      '7 – Não está em área diferenciada',
                      '8 – Povos e comunidades tradicionais',
                    ]"
                    label="Localização Diferenciada"
                    :rules="[requiredRule, localizacaoDiferenciadaRule]"
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Dependência Administrativa -->
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="formData.dependencia_administrativa"
                    :items="['3-Municipal']"
                    label="Dependência Administrativa"
                    :rules="[dependenciaAdminRule]"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-5">
            <v-card-title>Endereço</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    required
                    v-model="formData.cep"
                    label="CEP"
                    @change="pesquisarCep"
                    v-mask="'#####-###'"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    required
                    v-model="formData.codigo_municipio"
                    label="Código do Município"
                    :rules="[municipioRule]"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="8">
                  <v-text-field
                    @change="deixarMaisculo()"
                    :rules="[logradouroRule, requiredRule]"
                    v-model="formData.logradouro"
                    label="Logradouro"
                    required
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="formData.numero" label="Número" />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="formData.complemento" label="Complemento" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="formData.bairro" label="Bairro" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-5">
            <v-card-title>Contato</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formData.ddd"
                    label="DDD"
                    v-mask="'##'"
                    :rules="[dddRule]"
                  />
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="formData.celular"
                    label="Telefone Celular"
                    v-mask="'###########'"
                    :rules="[celularRule]"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.email"
                    label="E-mail"
                    type="email"
                    :rules="[emailRule]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-row class="mt-4">
        <v-col cols="6">
          <v-btn block color="error" disabled @click="submitForm('prev')">
            <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn block color="success" @click="submitForm('next')">
            <v-icon>mdi-chevron-right</v-icon> Próxima Etapa</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="erros.length > 0">
        <v-col cols="12" class="mt-4" style="background-color: red; color: white">
          <v-card-title>Erros encontrados no preenchimento dos dados</v-card-title>
          <v-card-text>
            <ul>
              <li>email invalido</li>
            </ul>
          </v-card-text>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
const listaMunicipios = require("@/assets/municipios.json");

export default {
  computed: {
    dataInicioFormatada: {
      get() {
        // Converte 'YYYY-MM-DD' para 'dd/MM/yyyy'
        if (!this.formData.data_inicio_ano_letivo) return "";
        const [ano, mes, dia] = this.formData.data_inicio_ano_letivo.split("-");
        return `${dia}/${mes}/${ano}`;
      },
      set(novaData) {
        // Converte 'dd/MM/yyyy' para 'YYYY-MM-DD'
        const partes = novaData.split("/");
        if (partes.length === 3) {
          const [dia, mes, ano] = partes;
          this.formData.data_inicio_ano_letivo = `${ano}-${mes}-${dia}`;
        }
      },
    },
    dataFinalFormatada: {
      get() {
        // Converte 'YYYY-MM-DD' para 'dd/MM/yyyy'
        if (!this.formData.data_final_ano_letivo) return "";
        const [ano, mes, dia] = this.formData.data_final_ano_letivo.split("-");
        return `${dia}/${mes}/${ano}`;
      },
      set(novaData) {
        // Converte 'dd/MM/yyyy' para 'YYYY-MM-DD'
        const partes = novaData.split("/");
        if (partes.length === 3) {
          const [dia, mes, ano] = partes;
          this.formData.data_final_ano_letivo = `${ano}-${mes}-${dia}`;
        }
      },
    },
  },
  data() {
    return {
      valid: false,
      tab: null,
      menuDataInicio: false,
      menuDataFinal: false,

      // Regras de validação
      emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      requiredRule: (v) => !!v || "Campo obrigatório",
      codigoRule: (v) => /^\d{8}$/.test(v) || "Código deve ter exatamente 8 dígitos",
      cepRule: (v) => /^\d{8}$/.test(v) || "CEP deve ter exatamente 8 dígitos",
      municipioRule: (v) => /^(?:\d{1,7})$/.test(v) || "Código do município deve ter até 7 dígitos",
      logradouroRule: (v) =>
        (typeof v === "string" && v.length <= 100) || "Logradouro deve ter até 100 caracteres",
      zonaRule: (v) => ["1-Urbana", "2-Rural"].includes(v) || "Selecione uma zona válida",
      localizacaoDiferenciadaRule: (v) =>
        v && ["1", "2", "3", "7", "8"].includes(v.charAt(0))
          ? true
          : "Selecione uma opção válida para localização",
      situacaoFuncionamentoRule: (v) =>
        v && ["1", "2", "3"].includes(v.charAt(0)) ? true : "Selecione uma opção válida",
      dependenciaAdminRule: (v) =>
        ["1-Federal", "2-Estadual", "3-Municipal", "4-Privada"].includes(v) ||
        "Selecione uma opção válida",
      // dataRule: (v) => this.validarData(v),
      dddRule: (v) => !v || /^\d{2}$/.test(v) || "DDD deve ter 2 dígitos",
      celularRule: (v) => !v || /^\d{10,11}$/.test(v) || "Celular deve ter 10 ou 11 dígitos",
      cnpjRule: (v) => !v || /\d{14}/.test(v.replace(/\D/g, "")) || "CNPJ deve ter 14 dígitos",
      codigoEscolaSedeRule: (v) => !v || /^\d{8}$/.test(v) || "Código deve ter 8 dígitos",

      formData: {
        codigo: "",
        situacao_funcionamento: "",
        data_inicio_ano_letivo: "",
        data_final_ano_letivo: "",
        descricao: "",
        cep: "",
        codigo_municipio: "",
        codigo_distrito: "05",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        ddd: "",
        celular: "",
        email: "",
        dependencia_administrativa: "",
        vinculo: "",
        cnpj_mantenedora: "",
        cnpj_escola: "",
        codigo_escola_sede: "",
      },
      erros: [],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    deixarMaisculo() {
      this.formData.logradouro.toUpperCase();
    },
    validarData(data) {
      if (!data) return "Campo obrigatório";
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!regex.test(data)) return "Data inválida (formato esperado: dd/mm/yyyy)";
      const [dia, mes, ano] = data.split("/");
      const date = new Date(ano, mes - 1, dia);
      if (date.getDate() !== dia || date.getMonth() + 1 !== mes || date.getFullYear() !== ano) {
        return "Data inválida";
      }
      return true;
    },

    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba00");
      this.formData = data;
      // this.formData['situacao_funcionamento'] = '1 - Em Atividade';
      // if (data.censo) {
      //   this.formData = data.censo;
      //   this.formData['situacao_funcionamento'] = '1 - Em Atividade';
      // }
      this.$loaderService.close();
    },
    async pesquisarCep(cep) {
      if (cep.length === 9) {
        const cepData = await this.$services.cepService.buscarDadosDoCep(cep);
        this.formData.cep = cepData.cep;
        this.formData.logradouro = cepData.rua.toUpperCase();
        this.formData.bairro = cepData.bairro;
        this.formData.codigo_municipio = this.getCodeMunicipio(cepData.cidade, cepData.uf);
      }
    },

    getCodeMunicipio(nomeMunicipio, nomeUF = null, codigoUF = null) {
      const municipioEncontrado = listaMunicipios.find((item) => {
        const matchNome = item["Nome do município"].toLowerCase() === nomeMunicipio.toLowerCase();

        if (nomeUF) {
          return matchNome && item["Nome UF"].toLowerCase() === nomeUF.toLowerCase();
        }

        if (codigoUF) {
          return matchNome && item["Código UF"] === parseInt(codigoUF, 10);
        }

        return matchNome;
      });

      return municipioEncontrado ? municipioEncontrado["Código do município"] : null;
    },

    submitForm(type) {
      if (this.$refs.form.validate()) {
        this.save(type);
      }
    },
    async save(type) {
      try {
        await this.$services.censoService.saveData(this.formData, "aba00");
        if (type === "next") {
          this.$emit("event", "tab-2");
        }

        // mandar um evento pro pai
      } catch (error) {
        this.$handleError(error);
      }
    },
  },
};
</script>
